import $ from 'jquery';
import { isCloudinaryImage, isCloudinaryVideo, isFile, isImage, isVideo } from 'utils/fileUtils';
import { getFileTooLargeMessage } from '../../common/utils';

const getFileLimit = (file, data) => {
  let limit;

  if (isImage(file) || isCloudinaryImage(file)) {
    limit = parseInt(data.customImageMaxSize);
  } else if (isVideo(file) || isCloudinaryVideo(file)) {
    limit = parseInt(data.customVideoMaxSize);
  } else {
    limit = parseInt(data.customRawMaxSize);
  }

  return limit || parseInt(data.customFileMaxSize);
};

export default (context, data) => {
  const file = data.files[0];
  const dfd = $.Deferred();

  let limit = 0;
  let isValid = true;

  if (isFile(file)) {
    limit = getFileLimit(file, data);

    if (limit && file.size > limit) {
      isValid = false;
    }
  }

  if (isValid) {
    dfd.resolveWith(context, [data]);
  } else {
    data.files.error = true;
    data.files[0] = { error: getFileTooLargeMessage(file.size, limit) };
    dfd.rejectWith(context, [data]);
  }

  return dfd.promise();
};
